module.exports = __webpack_public_path__ + "media/images/application/pub/icon-le-poulpe-920df1eb3ce277d44961aaa6ea83e2e3.svg";